// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const GENERATE_NDC_ERROR_CSV_STEP_SHAPES = [
  {
    stepType: PipelineStepType.GENERATE_NDC_ERROR_CSV,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Error file': {
        systemName: 'Error file',
        displayName: 'Error file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      },
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output file': {
        systemName: 'Output file',
        displayName: 'Output file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {}
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
